<div class="body">
  <mat-toolbar class="toolbar">
    <div class="menu d-print-none">
      <button mat-icon-button class="noOutline" (click)="toggleSidenav()">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
    <div class="full-width">
      <div class="row full-width">
        <div class="col-sm-12 col-md-2 d-print-none d-flex align-items-center">
          <span class="toolbar-title">{{ moduleTitle }}</span>
        </div>
        <div class="col-sm-12 col-md-6 d-flex align-items-center">
          <div class="d-flex flex-column align-items-start">
            <h1
              class="green"
              [ngClass]="{
                red: acceleratorCatalog?.pendingAcceleratorCatalog?.action == 3,
                yellow:
                  acceleratorCatalog?.pendingAcceleratorCatalog &&
                  acceleratorCatalog?.pendingAcceleratorCatalog?.action != 3 &&
                  (hasPrivilege(privilegeEnum.AcceleratorCatalogCreate) ||
                    hasRoles([roleEnum.RP])),
                green: acceleratorCatalog?.details?.accelerator?.status == 1,
                gray: acceleratorCatalog?.details?.accelerator?.status == 0
              }"
            >
              {{ accelerator?.name }}
              <span
                class="small"
                *ngIf="acceleratorCatalog?.details?.accelerator?.status == 0"
                >(Inactive)</span
              >
            </h1>
            <span
              *ngIf="
                acceleratorCatalog?.pendingAcceleratorCatalog &&
                (hasPrivilege(privilegeEnum.AcceleratorCatalogCreate) ||
                  hasRoles([roleEnum.RP]))
              "
              [ngClass]="{
                red: acceleratorCatalog?.pendingAcceleratorCatalog?.action == 3,
                yellow:
                  acceleratorCatalog?.pendingAcceleratorCatalog &&
                  acceleratorCatalog?.pendingAcceleratorCatalog?.action != 3 &&
                  (hasPrivilege(privilegeEnum.AcceleratorCatalogCreate) ||
                    hasRoles([roleEnum.RP])),
                green: acceleratorCatalog?.details?.accelerator?.status == 1,
                gray: acceleratorCatalog?.details?.accelerator?.status == 0
              }"
            >
              (
              {{
                acceleratorCatalog?.pendingAcceleratorCatalog?.statusName +
                  " - " +
                  acceleratorCatalog?.pendingAcceleratorCatalog?.actionName
              }}
              )
            </span>
          </div>
        </div>
        <div
          *ngIf="acceleratorCatalog"
          class="col-sm-12 col-md-4 d-flex align-items-center justify-content-end"
        >
          <ng-template #lastUpdate>
            <div class="col-3 pr-0 d-flex justify-content-end">
              <last-update [detailUsers]="detailUsers"></last-update>
            </div>
          </ng-template>
          <div
            class="small d-flex align-items-center"
            *ngIf="
              acceleratorCatalog.pendingAcceleratorCatalog &&
                (hasPrivilege(privilegeEnum.AcceleratorCatalogCreate) ||
                  hasRoles([roleEnum.RP]));
              else lastUpdate
            "
          >
            <span *ngIf="acceleratorCatalog.details.accelerator">
              Modified by:&nbsp;</span
            >
            <span *ngIf="!acceleratorCatalog.details.accelerator">
              Created by:&nbsp;</span
            >
            <span class="bold yellow">{{
              acceleratorCatalog.pendingAcceleratorCatalog.userCreatedBy?.name
            }}</span>
            &nbsp;on:&nbsp;
            <span class="date mr-3">{{
              acceleratorCatalog.pendingAcceleratorCatalog.createdOn | date
            }}</span>
            <mat-slide-toggle
              [(ngModel)]="showModification"
              *ngIf="
                acceleratorCatalog.details.accelerator &&
                acceleratorCatalog.pendingAcceleratorCatalog.action != 3
              "
            >
              Show Modification
            </mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>
  </mat-toolbar>
  <mat-sidenav-container
    class="sidenav-container mat-sidenav-collapse-transition"
    autosize
  >
    <mat-sidenav
      [ngClass]="{ 'mat-sidenav-collapsed': !isExpanded && !isShowing }"
      #sidenav
      opened="true"
      class="mat-side-nav-rad d-print-none"
      mode="side"
      (mouseenter)="mouseenter()"
      (mouseleave)="mouseleave()"
    >
      <!-- Section 1 -->
      <mat-nav-list>
        <mat-list-item>
          <mat-icon
            matListItemIcon
            *ngIf="!isExpanded && !isShowing"
            class="blue"
            >search</mat-icon
          >
          <filter-box
            (changed)="applyFilter($event)"
            *ngIf="isExpanded || isShowing"
          ></filter-box>
        </mat-list-item>

        <!-- Table -->
        <mat-list-item style="height: unset">
          <div *ngIf="isExpanded || isShowing">
            <app-accelerator-catalog-list
              (rowSelected)="rowSelected($event)"
              [filter]="filter"
            >
            </app-accelerator-catalog-list>
          </div>
        </mat-list-item>
      </mat-nav-list>

      <!-- Section 2 -->
      <mat-nav-list id="left-nav-buttons">
        <mat-list-item
          class="parent"
          *ngIf="accelerator && !showHistory"
          (click)="history(true)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Show History</span
          >
          <mat-icon matListItemIcon class="blue">history</mat-icon>
        </mat-list-item>

        <mat-list-item
          class="parent"
          *ngIf="accelerator && showHistory"
          (click)="history(false)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Hide History</span
          >
          <span matListItemIcon class="orange material-symbols-outlined">
            history_off
          </span>
        </mat-list-item>

        <mat-list-item
          (click)="create()"
          class="parent"
          *ngIf="hasPrivilege(privilegeEnum.AcceleratorCatalogCreate)"
        >
          <span class="full-width" *ngIf="isExpanded || isShowing"
            >Create New</span
          >
          <mat-icon matListItemIcon class="yellow">add_box</mat-icon>
        </mat-list-item>
      </mat-nav-list>
    </mat-sidenav>

    <mat-sidenav-content>
      <div class="d-flex flex-column justify-content-between">
        <div class="sidenav-content">
          <app-accelerator-catalog-details
            [acceleratorCatalog]="acceleratorCatalog"
            [showModification]="showModification"
            [showHistory]="showHistory"
            (saved)="refreshSaved($event)"
            (showModificationChanged)="showModification = $event"
          >
          </app-accelerator-catalog-details>
        </div>
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>

  <!-- "loading">
    <!-- Copyright 2017 Google Inc. All Rights Reserved.
      Use of this source code is governed by an MIT-style license that
      can be found in the LICENSE file at http://angular.io/license -->
  <!-- </overlay-loading> -->
</div>
